module.exports = __webpack_public_path__ + "media/audio95.0500ab5c.mp3";